import React, { Component } from 'react'
import Request from '../request'
import {
  SvgRecord
} from '../../Svg'
// import reqwest from 'reqwest';
/**
 * 用户中心组件
 */
const ICON_CLASS = {
  '电视': 'ico-tv',
  '电脑': 'ico-pc',
  '手机': 'ico-tel',
  '平板': 'ico-pad'
}
class Record extends Component {
    static defaultProps = {
      iconData: {
        url: '//faxian.youku.com/watch_record',
        title: '记录',
        className: 'ico-urecord'
      },
      maxNum: 6 // 播放记录显示最大条数
    }

    constructor (props) {
      super(props)
      this.state = {
        hoverClass: '',
        userInfoOk: false,
        isLogin: false,
        recordListok: false,
        num: 0
      }
      // 播放记录列表
      this.recordData = []
      this.dataIsOk = false
      this.isRequest = false
    }

    componentDidMount () {
      // 绑定登录回调
      this.props.Login.checkLogin((isLogin, userInfo) => {
        this.userInfo = userInfo
        this.setState({
          userInfoOk: true,
          isLogin: isLogin
        })
        this.getData()
      })
    }

    dealPlayLogData (playtag) {
      const _data = []
      playtag.d = []
      if (playtag.a.length > 0) {
        _data.push({ type: 'date', title: '今天' })
        playtag.a.map((item, index) => {
          if (index < this.props.maxNum) {
            return _data.push(item)
          }
        })
      }
      let _maxLen = 0
      if (_data.length < this.props.maxNum + 1) {
        _maxLen = this.props.maxNum - _data.length
        _data.push({ type: 'date', title: '昨天' })
        playtag.b.map((item, index) => {
          if (index < _maxLen) {
            return _data.push(item)
          }
        })
      } else {
        return _data
      }

      if (_data.length < this.props.maxNum + 2) {
        _maxLen = this.props.maxNum - _data.length
        _data.push({ type: 'date', title: '本周' })
        playtag.c.map((item, index) => {
          if (index < _maxLen) {
            return _data.push(item)
          }
        })
      }
      return _data
    }

    getData (config) {
      if (!this.isRequest && !this.dataIsOk) {
        this.isRequest = true
        Request.getPlayLog((data) => {
          if (data && data.playtag) {
            this.dataIsOk = true
            this.recordData = this.dealPlayLogData(data.playtag)
            this.setState({
              recordListok: true,
              num: this.recordData.length
            })
          }
          this.isRequest = false
        })
      }
    }

    handleMouseEnter (e) {
      this.setState({
        hoverClass: 'dropdown-open'
      })
    }

    handleMouseLeave () {
      this.setState({
        hoverClass: ''
      })
    }

    login (e) {
      this.props.Login.login()
      e.preventDefault()
    }

    renderItem (item, i) {
      if (item.type === 'date') {
        return (<dt key={i}>{item.title}</dt>)
      }
      const iconClassName = ICON_CLASS[item.devicename]
      return (
        <dd key={i}>
          <a href={`//v.youku.com/v_show/id_${item.videoid}.html?firsttime=${item.seconds}`} target='video' title={item.title}>{item.title}</a>
          <span className='rec-st'>
            <i className={`ico-device ${iconClassName}`} />
            看到
            {item.show_videoseq ? `${item.show_videoseq}集` : ''}
            {item.play_percent === '0%' ? '1%' : item.play_percent}
          </span>
        </dd>)
    }

    renderRecordList () {
      if (!this.state.isLogin || this.state.num === 0) {
        return (
          <div className='no-record'>
            <i className='no-record-bg' />
            <p>您暂时还没有观看记录呦～</p>
          </div>
        )
      } else {
        return (
          <dl className='rec-list'>
            {
              this.recordData.map((item, i) => {
                return (
                  this.renderItem(item, i)
                )
              })
            }
          </dl>
        )
      }
    }

    render () {
      let loginBtn = ''
      if (!this.state.isLogin) {
        loginBtn = (
          <div className='record-login'>
            <a href='javascript:void(0);' onClick={this.login.bind(this)}>登录</a>
              同步各端记录
          </div>
        )
      } else {
        loginBtn = (
          <div className='record-login' style={{ display: 'none' }} />
        )
      }
      return (
        <div className='u-record'
          onMouseEnter={this.handleMouseEnter.bind(this)}
          onMouseLeave={this.handleMouseLeave.bind(this)}>
          <div className={`dropdown ${this.state.hoverClass}`}>
            <div className='handle'>
              <a href={this.props.iconData.url} target='_blank' rel='noopener noreferrer' >
                <SvgRecord /><br />
                {this.props.iconData.title}</a>
            </div>
            <div className='panel'>
              <i className='arrow' />
              {loginBtn}
              {this.renderRecordList()}
              {
                this.state.num > 0
                  ? (<div className='u-bottom'>
                    <a target='_blank' href='//faxian.youku.com/watch_record' className='fr'>查看更多</a>
                  </div>) : ''}
            </div>
          </div>
        </div>
      )
    }
}
export default Record
